module.exports = __webpack_public_path__ + "assets/img/2005.3c413aac.svg";